import React from 'react';
import {
    Text,
} from '@chakra-ui/react';

export function TextoInicioCv(){

    return(
        <>
            <Text ml={2}>
                <strong>Próximo reto:</strong> Ingeniería Informática. Sin prisa.
            </Text>
        </>
    )
}
